import { render, staticRenderFns } from "./RicohMarketingServices.vue?vue&type=template&id=62f2f126&scoped=true&"
import script from "./RicohMarketingServices.vue?vue&type=script&lang=js&"
export * from "./RicohMarketingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2f126",
  null
  
)

export default component.exports